import { Component, EventEmitter, OnInit } from "@angular/core";

import {
    TCITenantSelectorType
} from "@tci/common";
import { ITCICEnvToolsComponentOutput, ITCIEnvToolsComponentInput } from "../../ng-tenant/tci-tenant-components";
import { AbstractTCITenantComponent } from "../../ng-tenant/tci-tenant-component";

@Component({
    selector: TCITenantSelectorType.TCI_ENV_TOOLS_ALERT.toString(),
    templateUrl: "./base-alert.component.html",
    styleUrls: ["./base-alert.component.less"]
})
export class BaseAlertComponent
    extends AbstractTCITenantComponent <EventEmitter<string>, ITCIEnvToolsComponentInput, ITCICEnvToolsComponentOutput<any>>
    implements OnInit {

    routeId: string;
    constructor() {
        super();
    }

    ngOnInit(): void {
        this.routeId = this.input.getOption().getRouteId();
    }
}
